import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const plumeNumber: number = -1;

const plume: any = undefined;

const open: boolean = true;

const pointView: boolean = false;

// Lê da preferência salva pelo usuário no login (localStorage). Default ligado.
const animationEnabled: boolean = (() => {
  try {
    const v = localStorage.getItem("plume_animation_enabled");
    if (v === null) return true;
    return v !== "false";
  } catch {
    return true;
  }
})();

const storedData: {
  facilityID: string;
  facilityPos: number;
  startDate: string;
  endDate: string;
  emissionSources: any;
  time: number;
  pollutant: string;
  timebase: string;
} = {
  facilityID: "",
  facilityPos: -1,
  startDate: "",
  endDate: "",
  emissionSources: [],
  time: 0,
  pollutant: "",
  timebase: "",
};

export const plumeNumberSlice = createSlice({
  name: "plume",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState: {
    plume: plume,
    plumeNumber: plumeNumber,
    open: open,
    storedData: storedData,
    pointView: pointView,
    animationEnabled: animationEnabled,
    modelingMode: "online" as "online" | "offline",
    thresholdsCache: {} as { [key: number]: number[] },
  },
  reducers: {
    updatePlume: (state, action: PayloadAction<any>) => {
      state.plume = action.payload;
    },
    updatePlumeNumber: (state, action: PayloadAction<number>) => {
      state.plumeNumber = action.payload;
    },
    setOpen: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
    setStoredData: (state, action: PayloadAction<any>) => {
      state.storedData = action.payload;
    },
    setViewPoints: (state, action: PayloadAction<boolean>) => {
      state.pointView = action.payload;
    },
    setAnimationEnabled: (state, action: PayloadAction<boolean>) => {
      state.animationEnabled = action.payload;
    },
    setModelingMode: (state, action: PayloadAction<"online" | "offline">) => {
      state.modelingMode = action.payload;
    },
    setThresholdsCache: (state, action: PayloadAction<{ [key: number]: number[] }>) => {
      state.thresholdsCache = action.payload;
    },
  },
});

export const {
  updatePlume,
  updatePlumeNumber,
  setOpen,
  setStoredData,
  setViewPoints,
  setAnimationEnabled,
  setModelingMode,
  setThresholdsCache,
} = plumeNumberSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state

export default plumeNumberSlice.reducer;
